<template>
  <div style="width: 100%">
    <h4 class="mt-2">Berechnung</h4>
    <div class="row">
      <div class="col-lg-6 col-sm-12">
        <div class="eingaben mt-3" id="eingaben_table">
          <b>Eingaben:</b>
          <div class="mt-2">
            <font-awesome-icon icon="map-marker-alt" class="content-icon" />
            <span
              id="eingaben_table_standort"
            >Windzone: {{windzone}}, {{standort}}, Standorthöhe: {{standorthoehe}}m, Exponierte Lage: Nein</span>
          </div>
          <div class="mt-2">
            <font-awesome-icon icon="home" class="content-icon" />
            <span id="eingaben_table_gebaeude">
              <span v-if="geschlossen == 'true'">Geschlossen: Ja,</span>
              <span v-else>Geschlossen: Nein,</span>
              {{dachform}}, h = {{gebaeudehoehe}}m, a = {{trauflaenge}}m,
              <span
                v-if="dachform != 'Walmdach'"
              >b = {{giebellaenge}}, α = {{dachneigung}}°</span>
              <span
                v-if="dachform == 'Walmdach'"
              >b = {{walmtrauflaenge}}m, α = {{dachneigung}}° β = {{walmneigung}}°</span>
            </span>
          </div>
          <div class="mt-2">
            <font-awesome-icon icon="clone" class="content-icon" />
            <span
              v-if="pfannenmodell != ''"
              id="eingaben_table_ziegel"
            >{{pfannenmodell}}, {{dachpfannenObject.decklaengemm}}mm x {{dachpfannenObject.deckbreitemm}}mm, Lattung: {{lattung}}</span>
          </div>
        </div>
        <div
          v-if="calculationResult != null && calculationResult != undefined"
          class="table-responsive"
        >
          <table class="table mt-4" id="records_table" v-if="!calculationResult.Error">
            <thead>
              <tr>
                <th>Kategorie</th>
                <th>Fläche in m2</th>
                <th>Klammerschema</th>
                <th>Anzahl Klammern</th>
              </tr>
            </thead>
            <tr v-if="dachform != 'Walmdach'">
              <th>Ortgang</th>
              <td>{{calculationResult.FlaecheKat1}}</td>
              <td v-if="calculationResult.WindlastKategorie1Befestigung == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie1Befestigung}}</td>
              <td>{{calculationResult.AnzahlKlammernKat1}}</td>
            </tr>
            <tr v-if="dachform == 'Walmdach'">
              <th>Grat</th>
              <td>{{calculationResult.FlaecheKat1Grat}}</td>
              <td v-if="calculationResult.WindlastKategorie1Befestigung == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie1Befestigung}}</td>
              <td>{{calculationResult.AnzahlKlammernKat1Grat}}</td>
            </tr>
            <tr v-if="dachform == 'Walmdach'">
              <th>Walm</th>
              <td>{{calculationResult.FlaecheKat1Walm}}</td>
              <td v-if="calculationResult.WindlastKategorie1BefestigungWalm == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie1BefestigungWalm}}</td>
              <td>{{calculationResult.AnzahlKlammernKat1Walm}}</td>
            </tr>
            <tr>
              <th>Innenbereich</th>
              <td>{{calculationResult.FlaecheKat2}}</td>
              <td v-if="calculationResult.WindlastKategorie2Befestigung == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie2Befestigung}}</td>
              <td>{{calculationResult.AnzahlKlammernKat2}}</td>
            </tr>
            <tr>
              <th>Traufe</th>
              <td>{{calculationResult.FlaecheKat3}}</td>
              <td v-if="calculationResult.WindlastKategorie3Befestigung == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie3Befestigung}}</td>
              <td>{{calculationResult.AnzahlKlammernKat3}}</td>
            </tr>
            <tr>
              <th>First</th>
              <td>{{calculationResult.FlaecheKat4}}</td>
              <td v-if="calculationResult.WindlastKategorie4Befestigung == 'none'">-</td>
              <td v-else>{{calculationResult.WindlastKategorie4Befestigung}}</td>
              <td>{{calculationResult.AnzahlKlammernKat4}}</td>
            </tr>
            <tr>
              <th>Gesamt</th>
              <td>{{calculationResult.FlaecheDach}}</td>
              <td>-</td>
              <td>{{calculationResult.AnzahlKlammernGesamt}}</td>
            </tr>
            <tr>
              <th>Klammertyp</th>
              <td>
                <b>{{dachpfannenObject.klammertyp}}</b>
              </td>
              <td>
                <button
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#klammerModal"
                >Klammerbild</button>
              </td>
              <td>
                <button
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#klammerAnwendungModal"
                >Anwendungsbeispiel</button>
              </td>
            </tr>
          </table>
          <div class="error-msg" v-else>{{calculationResult.Errormessage}}</div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="karten-halter mt-2">
          <Gebaeudegrafik />
        </div>
        <div class="karten-halter mt-2">
          <component v-if="dachform != ''" v-bind:is="dachform+'Seitenansicht'"></component>
        </div>
        <div class="dachdetails mt-2">
          <DachdetailsSattelPult v-if="dachform != '' && dachform != 'Walmdach'" />
          <DachdetailsWalm v-if="dachform != '' && dachform == 'Walmdach'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Gebaeudegrafik from "../svg/Gebaeudegrafik";
import SatteldachSeitenansicht from "../svg/SatteldachSeitenansicht";
import PultdachSeitenansicht from "../svg/PultdachSeitenansicht";
import WalmdachSeitenansicht from "../svg/WalmdachSeitenansicht";
import DachdetailsSattelPult from "../svg/DachdetailsSattelPult";
import DachdetailsWalm from "../svg/DachdetailsWalm";

export default {
  name: "Berechnung",
  components: {
    Gebaeudegrafik,
    SatteldachSeitenansicht,
    PultdachSeitenansicht,
    WalmdachSeitenansicht,
    DachdetailsSattelPult,
    DachdetailsWalm
  },
  computed: {
    ...mapState({
      windzone: state => state.inputs.windzone,
      gebaeudehoehe: state => state.inputs.gebaeudehoehe,
      standort: state => state.inputs.standort,
      standorthoehe: state => state.inputs.standorthoehe,
      dachform: state => state.inputs.dachform,
      deckunterlage: state => state.inputs.deckunterlage,
      dachneigung: state => state.inputs.dachneigung,
      walmdachneigung: state => state.inputs.walmdachneigung,
      trauflaenge: state => state.inputs.trauflaenge,
      giebellaenge: state => state.inputs.giebellaenge,
      geschlossen: state => state.inputs.geschlossen,
      walmtrauflaenge: state => state.inputs.walmtrauflaenge,
      walmneigung: state => state.inputs.walmneigung,
      pfannenmodell: state => state.inputs.pfannenmodell,
      dachpfannen: state => state.inputs.dachpfannen,
      lattung: state => state.inputs.lattung,
      dachpfannenObject: state => state.inputs.dachpfannenObject,
      calculationResult: state => state.inputs.calculationResult
    }),
    ...mapGetters(["isErlaubt"])
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dachdetails {
  width: 95%;
}

.karten-halter {
  margin: 5px 10px 10px 10px;
  float: left;
  height: 250px;
}

@media (max-width: 992px) {
  .karten-halter {
    height: calc(30vh * 0.6);
    margin: 5px 15px 10px 10px;
    text-align: center;
  }
}

.content-icon {
  width: 30px;
  text-align: center;
}

th {
  color: #006fba;
  border: none;
}

td {
  border: none;
}

thead {
  border-bottom: 1px solid #dee2e6;
}

.error-msg {
  margin-top: 30px;
  padding: 10px;
  background-color: rgb(186, 0, 0);
  text-align: center;
  color: white;
}
</style>